import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from '@truefit/http-utils';

import {
  TRANSCODING_PROFILES_QUERY_KEY,
  TRANSCODING_PROFILES_URL,
  type TranscodingProfile,
  type TranscodingProfileOutput,
} from './useTranscodingProfilesQuery';

/** The editable fields shared by create + update. */
export interface TranscodingProfileInput {
  /** Stable slug / machine id (unique), e.g. "tp_broadcast_1080". */
  name: string;
  /** Human title shown in the editor, e.g. "Broadcast 1080p59.94". */
  displayName: string;
  description?: string | null;
  output: TranscodingProfileOutput;
}

export const useCreateTranscodingProfileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: TranscodingProfileInput): Promise<TranscodingProfile> => {
      const { data } = await post<TranscodingProfile>(TRANSCODING_PROFILES_URL, input);
      return data;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: TRANSCODING_PROFILES_QUERY_KEY }),
  });
};

export default useCreateTranscodingProfileMutation;
